import React, { useState } from 'react'
import {
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  useToast,
} from '@chakra-ui/react'
import { CheckCircleIcon } from '@chakra-ui/icons'
import './style.css'
import { REPOSITORY } from '../../../api/repository/Repository'

export default function Banners() {
  const [isOpen, setIsOpen] = useState(false)
  const toast = useToast()

  const currentDate = new Date()
  const deadline = new Date('2024-12-19T23:59:59') //Para banner cyber (EM-754)

  const bannerUrl =
    currentDate <= deadline
      ? 'https://assetsamipass.blob.core.windows.net/companies/banners/banner5.png'
      : 'https://assetsamipass.blob.core.windows.net/companies/banners/banner1.png'

  const companyName = REPOSITORY.local.company.getUserData()?.user.sEmpresa

  const handleOpenModal = async () => {
    await REPOSITORY.wsEmpresa.company
      .SendEmailCompanyAdvisor(companyName, 'Giftcard ' + companyName)
      .then(() => {
        setIsOpen(true)
      })
      .catch((error) => {
        console.error('Error enviando el correo:', error)
        toast({
          title: 'Error.',
          description: 'Hubo un problema al enviar el correo.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
      })
  }

  const handleCloseModal = () => {
    setIsOpen(false)
  }

  return (
    <HStack spacing="10vw" className="item" boxSize="container">
      <img
        objectFit="fill"
        padding="32px"
        style={{
          width: '100vw',
          height: 'auto',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          cursor: 'pointer',
        }}
        src={bannerUrl}
        alt="Banner"
        onClick={handleOpenModal}
      />
      <Modal isOpen={isOpen} onClose={handleCloseModal} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader display="flex" alignItems="center">
            <CheckCircleIcon color="green.500" boxSize={6} />
          </ModalHeader>
          <ModalBody textAlign={'center'}>
            <b>Serás contactado por tu Ejecutiva.</b>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={handleCloseModal}>
              Aceptar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* <Image
        padding="32px"
        style={{
          maxWidth: '100%',
          height: 'auto',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        src={
          'https://assetsamipass.blob.core.windows.net/companies/banners/banner2.png'
        }
      />
      <Image
        src={
          'https://assetsamipass.blob.core.windows.net/companies/banners/banner3.png'
        }
        style={{
          maxWidth: '100%',
          height: 'auto',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        padding="32px"
      /> */}
    </HStack>
  )
}
